import Vue from 'vue'
import { URL_ORGANIZATION } from '@/constants/urls.js'
import { CURRENT_ORGANIZATION, ERRORS, AXIOS_REQUESTS, GENERAL_FILES } from '@/constants/store.js'

const state = {
  [CURRENT_ORGANIZATION.STATE.ORGANIZATION]: null
}

const actions = {
  async [CURRENT_ORGANIZATION.ACTIONS.GET_CURRENT_ORGANIZATION] ({ dispatch, commit }) {
    const model = {
      url: `${Vue.getIdentityHost()}${URL_ORGANIZATION}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(CURRENT_ORGANIZATION.MUTATIONS.GET_CURRENT_ORGANIZATION, resp.data)
  },
  async [CURRENT_ORGANIZATION.ACTIONS.GET_REGISTRATION_CARD] ({ commit, dispatch }) {
    const url = `${Vue.getIdentityHost()}${URL_ORGANIZATION}/registrationCard?${Vue.helpers.getQueryParamsString()}`

    await dispatch(GENERAL_FILES.ACTIONS.DOWNLOAD_FILE_WITH_SETTINGS, url, { root: true })
  },
  async [CURRENT_ORGANIZATION.ACTIONS.CLEAR_CURRENT_ORGANIZATION] ({ commit }) {
    commit(CURRENT_ORGANIZATION.MUTATIONS.CLEAR_CURRENT_ORGANIZATION)
  }
}

const mutations = {
  [CURRENT_ORGANIZATION.MUTATIONS.GET_CURRENT_ORGANIZATION] (state, organization) {
    state[CURRENT_ORGANIZATION.STATE.ORGANIZATION] = organization
  },
  [CURRENT_ORGANIZATION.MUTATIONS.CLEAR_CURRENT_ORGANIZATION] (state) {
    state[CURRENT_ORGANIZATION.STATE.ORGANIZATION] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
